module.exports = __webpack_public_path__ + "static/media/Club-puebla.77a15149.png";